import React, { ReactNode } from 'react';
import useAuditNavigationTrace from "../../hooks/useAuditNavigationTrace";

const AuditTraceProvider = ({ children }: { children: ReactNode }) => {
  useAuditNavigationTrace();
  return <>{children}</>;
};

export default AuditTraceProvider;
